<template>
  <div class="pattern-picker" id="app"
       :class="[showPreview?'preview-open':'preview-close',getMode,popUpOpen?'pop-up-open':'']">
    <transition name="fade">
      <section class="pattern-app" v-if="popUpOpen||getMode==='embed'" v-on-clickaway="closeModal">
        <aside v-if="!hideCategoryFilter || !hideColorFilter" class="pattern-filters"
               :class="[toggleFilters?'toggle-filters':'']">
          <div class="pattern-filters-category" v-if="!hideCategoryFilter">

            <h2>{{ $t('filters.category.label') }}
              <spinner v-if="loading"></spinner>
            </h2>
            <select v-model="activeBoard" :disabled="loading">
              <option disabled>{{ $t('filters.category.choose') }}</option>
              <option v-for="option in getBoards" :key="option.id" v-bind:value="option.id">{{ option.name }}</option>
            </select>
          </div>

          <div class="pattern-filters-color" v-if="!hideColorFilter">
            <h2>{{ $t('filters.color.label') }}
              <spinner v-if="loading"></spinner>
            </h2>
            <div class="group">
              <label v-for="colors in getColors" :key="colors.id" class="filter"
                     :class="[(colorID === colors.id)?'selected':'']"
                     :title="colors.name" @click="setColor(colors.id)">
                    <span class="" :style="{backgroundColor:colors.hex}">
                    </span>
              </label>
            </div>
          </div>

          <div class="filter-toggle" @click="toggleFilter">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>
            </svg>&nbsp;
            <span>{{ toggleFilters ? $t('filters.toggle.close') : $t('filters.toggle.open') }}</span>
          </div>

          <closer class="pattern-closer" @unsetpreview="unSetPreview" @hidepreview="closeModal"></closer>
        </aside>

        <main class="pattern-grid">

          <div class="pattern-collection">
            <template v-if="loading">
              <thumb v-for="skeleton in getSkeleton" :key="skeleton.id" :skeleton=true>
              </thumb>
            </template>
            <template else>
              <template v-if="getPatterns.length">
                <thumb v-for="pattern in getPatterns" :key="pattern.id" :pattern=pattern>
                </thumb>
              </template>
            </template>
          </div>
          <template v-if="!loading">
            <template v-if="!getPatterns.length">
              <span class="_error">{{ $t('pattern.none-found') }}</span>
            </template>
          </template>
          <footer> <closer class="md:hidden" @unsetpreview="unSetPreview" @hidepreview="closeModal"></closer></footer>
        </main>

        <preview></preview>
        <popup></popup>
      </section>
    </transition>
  </div>
</template>

<script>

/**
 * @Todo Mobile Filters
 * @Todo Layout embed
 * @Todo callback Modal, to preserve styling StateC: Loading, StateA: Succes, StateB: failes :)
 * @Todo
 */

import store from '@/store'
import i18n from "@/i18n";
import thumb from "@/components/Thumb";
import preview from "@/components/Preview";
import closer from "@/components/Closer";
import spinner from "@/components/Spinner";
import popup from "@/components/Popup";
import {EventBus} from '@/event-bus.js';
import {directive as onClickaway} from 'vue-clickaway';


export default {
  store,
  i18n,
  name: 'App',
  directives: {
    onClickaway: onClickaway,
  },
  components: {
    popup,
    spinner,
    thumb,
    preview,
    closer
  },
  props: {
    token: {
      type: String,
      default: ''
    },
    api: {
      type: String,
      default: null
    },
    startCollection: {
      type: String,
      default: null
    },
    startPattern:{
      type:String,
      default:null,
    },
    mode: {
      type: String,
      default: 'embed'
    },
    language: {
      type: String,
      default: 'en'
    },
    hideCategoryFilter: {
      default: false,
      type: Boolean
    },
    hideColorFilter: {
      default: false,
      type: Boolean,
    },
    callbackElement: {
      type: String,
      default: null
    },
    callbackFunction: {
      type: String,
      default: null
    },
    triggerElement: {
      type: String,
      default: null
    },
    hideSelect: {
      type: Boolean,
      default: false,
    },
    brandingColor: {
      type: String,
      default: ''
    },
    currentPattern:{

    }
  },
  data() {
    return {
      colorID: null,
      defaultcolors: [
        {
          "id": 1,
          "hex": "#C51531",
          "name": this.$t('filters.color.colors.red')
        },
        {
          "id": 2,
          "hex": "#ED6946",
          "name": this.$t('filters.color.colors.orange')
        },
        {
          "id": 3,
          "hex": "#FCE616",
          "name": this.$t('filters.color.colors.yellow')
        },
        {
          "id": 4,
          "hex": "#0A9753",
          "name": this.$t('filters.color.colors.green')
        },
        {
          "id": 5,
          "hex": "#1580B6",
          "name": this.$t('filters.color.colors.blue')
        },
        {
          "id": 6,
          "hex": "#952C87",
          "name": this.$t('filters.color.colors.lila')
        },
        {
          "id": 7,
          "hex": "#F39EA8",
          "name": this.$t('filters.color.colors.pink')
        },
        {
          "id": 8,
          "hex": "#814514",
          "name": this.$t('filters.color.colors.bronze')
        },
        {
          "id": 9,
          "hex": "#989898",
          "name": this.$t('filters.color.colors.silver')
        },
        {
          "id": 10,
          "hex": "#FFFFFF",
          "name": this.$t('filters.color.colors.white')
        },
        {
          "id": 11,
          "hex": "#000000",
          "name": this.$t('filters.color.colors.black')
        }
      ],
      colors: this.defaultcolors,
      popUpOpen: false,
      toggleFilters: false,
      externalBackgroundProcessing: true,
    }
  },

  watch: {
    colorID: function (data) {
      this.$store.dispatch('setColorId', data)
    }
  },
  methods: {
    toggleFilter() {
      if (this.toggleFilters) {
        this.toggleFilters = false
      } else {
        this.toggleFilters = true;
      }
    },
    setColor(data) {
      if (this.colorID === data) {
        this.colorID = null;
      } else {
        this.colorID = data;
      }
    },
    getSelectedPattern() {
      return this.patternData
    },
    openModal() {
      if (!this.popUpOpen) {
        this.$nextTick().then(() => {
          setTimeout(() => {
            this.popUpOpen = true
          }, 50);
        });
      }
    },
    closeModal() {
      if (this.patternData) {
        this._doCallback(
            () => {
              if (this.popUpOpen) {
                this.$nextTick().then(() => {
                  setTimeout(() => {
                    this.popUpOpen = false;
                  }, 50);
                });
              }
            }
        );
      } else {
        if (this.popUpOpen) {
          this.$nextTick().then(() => {
            setTimeout(() => {
              this.popUpOpen = false
            }, 50);
          });
        }
      }
    },

    confirmSelection() {
      this._doCallback(
          () => {
            this.closeModal()
          }
      );
    },

    /**
     * Methods does a callback to the callbackElement and / or the callback function
     * with clean data, so we do not expose to  much data.
     * @private
     */
    _doCallback(callbackFunction) {
      let callbackData = this.patternData;
      /** Do callback to callbackElement by setting the ID of the selected Item */
      if (this.callbackElement) {
        if (document.querySelector(this.callbackElement)) {
          document.querySelector(this.callbackElement).value = callbackData.id;
        }
      }
      /** Do callback to callbackFunction */
      if (this.callbackFunction) {
        if (typeof window[this.callbackFunction] === "function") {
          window[this.callbackFunction](callbackData);
        }
      }

      /** Creates a nice little callback to the dom. */
      let _SelectEvent = new CustomEvent("patternPickerPatternSelected", {
        detail: callbackData
      });
      window.dispatchEvent(_SelectEvent);
      /** run the callback function **/
      if (typeof callbackFunction === "function") {
        callbackFunction();
      }

    },

    unSetPreview() {
      this.$store.dispatch('unsetSelected');
    },
    setExternalBackgroundProcessing(state) {
      store.dispatch('setExternalProcess', state);
    },

    showExternalBackgroundModal(method = 'processed') {
      let data = {};
      switch (method) {
        case "error":
            data = {
              type: 'error',
              closeable:true,
              title: i18n.t('eb.process.error.title'),
              text: i18n.t('eb.process.error.text'),
            }
          break;
        case "duplicate":
          data = {
            type: 'duplicate',
            title: i18n.t('eb.process.duplicate.title'),
            text: i18n.t('eb.process.duplicate.text'),
          }
          break;
        case "processed":
        default:
          data = {
            type: 'processed',
            title: i18n.t('eb.process.processed.title'),
            text: i18n.t('eb.process.processed.text'),
          }

          break;

      }
      EventBus.$emit('openInfoModal', data);
    },
    setBeginPattern(id){
      this.$store.dispatch('setStartPattern',id)
    }
  },

  computed: {
    patternData() {
      let callbackData = Object.assign({}, this.getSelected);
      callbackData.valid = false;
      if (callbackData.id) {
        callbackData.valid = true;
        if (callbackData.colors) {
          callbackData.colors = Object.assign({}, callbackData.colors);
        } else {
          delete callbackData.colors;
        }
      }
      return callbackData;
    },
    activeBoard: {
      get() {
        return this.$store.state.boardId;
      },
      set(value) {
        this.$store.dispatch('setBoardId', value);
        this.$store.dispatch('fetchPatterns');
      }
    },
    showPreview() {
      return this.$store.getters.showPreview;
    },
    loading() {
      return this.$store.state.loading
    },

    isPopUpmode() {
      return (this.mode.toLowerCase() === "pop-up");
    },

    getSkeleton() {
      const _return = [];
      let i = 0;
      for (i = 0; i < 15; i++) {
        _return.push(i)
      }
      return _return;
    },
    getBoards() {
      return this.$store.getters.getBoards;
    },
    getPatterns() {
      return this.$store.getters.getPatterns;
    },
    getError() {
      return this.$store.getters.getError;
    },
    getColors() {
      return this.colors ? this.colors : this.defaultcolors;
    },
    getSelected() {
      return this.$store.state.selected;
    },
    getMode() {
      return this.mode.toLowerCase();
    }
  },
  created() {
    this.$store.dispatch('setToken', this.token)
    this.$store.dispatch('setBaseURL', this.api)
    this.$store.dispatch('setBoardId', this.startCollection);
    this.$store.dispatch('fetchBoards');
    if(this.startPattern){
        this.setBeginPattern(this.startPattern);
    }
  },
  updated(){
    if (this.brandingColor) {
      let validate = new RegExp(/^#([0-9a-f]{6}|[0-9a-f]{3})$/i);
      if (validate.test(this.brandingColor)) {
        let root = document.querySelector('motiflow-picker');
        let app = root.shadowRoot.querySelector('.pattern-app');     
        if (app) {
          app.style.setProperty('--color-primary', this.brandingColor);
          }
      }
    }
  },
  mounted() {
    if (!this.token.length) {
      console.warn("PatternPicker: No token isset. You can retrieve your token via the motiflow partner portal");
      this.$destroy();
    } else {
      this.$i18n.locale = this.language;
      this.$store.dispatch('fetchPatterns');
      if (this.triggerElement) {
        if (document.querySelectorAll(this.triggerElement).length) {
          document.querySelectorAll(this.triggerElement).forEach(btn =>
              btn.addEventListener("click", () =>  this.openModal())
          )
        }
      }
      EventBus.$on('externalModalOpen',this.openModal);
      EventBus.$on('externalModalClose',this.closeModal);
      EventBus.$on('externalModalInfo',this.showExternalBackgroundModal);
      EventBus.$on('externalButtonTrigger',this.setExternalBackgroundProcessing);
      EventBus.$on('externalSetPattern',this.setBeginPattern);
      window.MotiflowPicker = window.MotiflowPicker || (function(){
        return {
          /**
           * Returns selected pattern data
           * @returns {*}
           */
          getSelected(){
            let x = store.getters.getSelected;
            let callbackData = Object.assign({}, x);
            callbackData.valid = false;
            if (callbackData.id) {
              callbackData.valid = true;
              if (callbackData.colors) {
                callbackData.colors = Object.assign({}, callbackData.colors);
              } else {
                delete callbackData.colors;
              }
            }
            return callbackData;

          },
          setSelected(id) {
            if(id){
              EventBus.$emit('externalSetPattern',id);
            }
          },
          /**
           * Opens the pattern-picker as a modal.
           */
          openModal(id){
            if(id){
              EventBus.$emit('externalSetPattern',id);
            }
            EventBus.$emit('externalModalOpen',true);
          },
          /**
           * Closes the pattern-picker.
           */
          closeModal(){
            EventBus.$emit('externalModalClose',false);
          },
          /**
           * Applies a loader to the confirm selection button.
           */
          triggerPatternPickedProcesss: function(state){
            EventBus.$emit('externalButtonTrigger',state);
          },

          /**
           * Displays a success modal.
           */
          triggerPatternPickedProcessed:function(){
            EventBus.$emit('externalModalInfo','processed');
          },
          /**
           * Displays a already applied modal.
           */
          triggerPatternPickedAlreadyProcessed:function(){
            EventBus.$emit('externalModalInfo','duplicate');
          },
          /**
           * Displays a error applied modal.
           */
          triggerPatternPickedError:function(){
            EventBus.$emit('externalModalInfo','error');
          },
        };
      }());

    }
  }
}
</script>

<style>
@tailwind base;
@tailwind utilities;
@tailwind screens;

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.filter-toggle {
  @apply md:hidden flex flex-row cursor-pointer text-gray-700 px-2 py-1 m-2 z-10 leading-tight items-center justify-center;
}

.filter-toggle svg {
  height: 16px;
  width: 16px;
  @apply transform rotate-90
}

.pattern-picker {
  @apply relative
}

.pattern-picker.pop-up {
  @apply hidden h-0 w-0;
}

.pattern-picker.pop-up.pop-up-open {
  @apply rounded block bg-gray-400 bg-opacity-50 lg:p-10 absolute top-0 left-0 w-screen h-screen overflow-hidden shadow;
  z-index: 999999;
}


.pattern-app {
  @apply font-sans leading-6 relative h-screen flex flex-col md:flex-row;
  --color-primary: #67baaf;
  --pattern-thumbnail: 236px;
  --pattern-preview: calc(var(--pattern-thumbnail) * 2);
}


.pattern-picker.pop-up .pattern-app {
  @apply rounded overflow-hidden;
  height:90vh;
}


.pattern-app.filter-tops {

}

.pattern-app.modal-open {
  @apply overflow-hidden h-screen;
}

.pattern-filters {
  @apply py-4 px-6 md:p-6 bg-white border-gray-200 border-r border-solid w-full md:w-1/5 md:flex flex-col;
}

.pattern-filters.toggle-filters {
}

.pattern-filters .pattern-closer{
  @apply hidden md:block;
}
.pattern-filters.toggle-filters .pattern-filters-category,
.pattern-filters.toggle-filters .pattern-filters-color {
  @apply flex;
}

.pattern-filters-category {
  @apply hidden md:flex flex-col flex-nowrap;
}

.pattern-filters-category select {
  @apply appearance-none text-gray-700 border  border-gray-100 border-solid px-3 py-2 mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md shadow-sm;
  background-image: url("data:image/svg+xml; utf8, <svg class=\"text-gray-300\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M6 8l4 4 4-4\"/></svg>");
  background-position: right center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
}

.pattern-filters-color {
  @apply hidden md:flex flex-col flex-nowrap;
}

.pattern-filters-category h2,
.pattern-filters-color h2 {
  @apply mt-6 text-base  text-sm font-medium text-gray-700 flex flex-row items-center justify-start;
}

.pattern-filters-color .group {
  @apply flex flex-row flex-wrap;
}

.pattern-filters-color .filter {
  @apply block w-8 h-8 md:w-6 md:h-6 cursor-pointer rounded mr-2 mb-1 border-2 border-gray-100 overflow-hidden;
}

.pattern-filters-color .filter span {
  @apply rounded  block w-full h-full border border-white;
}

.pattern-filters-color .selected {
  @apply border-primary;
}

.pattern-grid {
  @apply h-full overflow-scroll bg-gray-100 w-full;
}

.pattern-grid ._error {
  @apply w-full h-1/2 flex items-center justify-center text-gray-500 text-base md:text-lg;
}

.pattern-grid footer{
  @apply flex fixed bottom-0 md:hidden py-4 px-6 md:p-6 bg-white border-gray-200 border-t border-solid w-full md:w-1/5 md:flex flex-col;

}

.pattern-collection {
  @apply grid p-4 gap-5 justify-center my-0 mx-auto;
  grid-template-columns: repeat(auto-fill, var(--pattern-thumbnail));
}

.pattern-collection .no-patterns {
  @apply m-auto bg-purple-300;
}

footer .pattern-closer{

}

</style>
